import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import {UserService} from '../../../services/user.service';
import {ConfigService} from '../../../services/config.service';
import {Meta, Title} from '@angular/platform-browser';
import {NgxSpinner} from 'ngx-spinner/lib/ngx-spinner.enum';
import Swal from 'sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {PasswordService} from "../../../services/password.service";


@Component({
    selector: 'app-forgetIP',
    templateUrl: './forgetIP.component.html',
    styleUrls: ['./forgetIP.component.css'],
    standalone: false
})
export class ForgetIPComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);
  // tslint:disable-next-line:variable-name
  id_new_password: any;
  // tslint:disable-next-line:max-line-length variable-name
  client_email: any;
  // tslint:disable-next-line:max-line-length variable-name
  login: any;
  // tslint:disable-next-line:variable-name
  public email_send: any;
  addingSuccess: boolean;
  public text: any;
  // tslint:disable-next-line:variable-name
  public email_reserter: any;
  // tslint:disable-next-line:max-line-length variable-name
  text_login: boolean;
  // tslint:disable-next-line:variable-name
  text_new_password: boolean;
  // tslint:disable-next-line:variable-name
  password_change = true;

  // tslint:disable-next-line:variable-name
  new_password: any;
  public isPasswordInvalid: boolean = false;

  // tslint:disable-next-line:max-line-length
  constructor(public meta: Meta, public pageTitle: Title, private activatedRoute: ActivatedRoute, private router: Router, private userService: UserService, private passwordService: PasswordService) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (typeof params['email'] === 'undefined') {
        this.text_login = true;
      }
      if (typeof params['email'] !== 'undefined') {
        this.text_new_password = true;
      }
      this.email_reserter = params['login'];
    });
  }

  getCurrentDate() {
    // tslint:disable-next-line:prefer-const
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();

    return dd + '-' + mm + '-' + yyyy;
  }

  get_user(id) {
    this.userService.getUserDetailsForPassword(id)
      .subscribe(res => {
        this.id_new_password = res.data.id;
        this.client_email = res.data.email;
        this.login = res.data.login;
        if (res.data.length === 0) {
          this.router.navigate(['/']);
        }
        // tslint:disable-next-line:max-line-length
        this.router.navigate(['/password/forget'], {
          queryParams: {
            email: this.client_email,
            login: this.login,
            date: this.getCurrentDate(),
            application: 'certi_kap_v1'
          }
        });
      }, (err) => {
        this.router.navigate(['/']);
      });
  }

  send_new_password() {
    // @ts-ignore
    if (this.email_send === null || typeof this.email_send === 'undefined') {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.enterUsername')
      });
      return false;
    } else {
      // @ts-ignore
      const body = {
        login: this.email_send
      };
      this.userService.forget_password_user(body)
        .subscribe(res => {
          this.email_send = '';
          if (res.success === true) {
            Swal.fire({
              icon: 'success',
              title: this.runtimeTranslate.instant('alerts.mailSent'),
              text: res.message,
            });
          }else{
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.error'),
              text: res.message,
            });
          }
        }, (err) => {
          console.log(err);
        });
    }
  }

  change_password() {
    if (this.new_password === null || typeof this.new_password === 'undefined') {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.enterNewPassword')
      });
      return false;
    }
    else if (!this.passwordService.verifyPassword(this.new_password)){
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('auth.passwordRules')
      });
      this.isPasswordInvalid = true;
      return false;
    }
    else {
      // @ts-ignore
      const body = {
        login: this.email_reserter,
        new_password: this.new_password
      };
      this.userService.change_password_user(body)
        .subscribe(res => {
          this.new_password = '';
          this.password_change = false;
          if (res.success === true) {
            Swal.fire({
              icon: 'success',
              title: this.runtimeTranslate.instant('alerts.passwordUpdated'),
              text: res.message,
            });
          }else{
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.error'),
              text: res.message,
            });
          }
        }, (err) => {
          console.log(err);
        });
    }
  }

}
